// @flow
import { normalizeOptions } from "../../utils";
import type { OptionT } from "../../misc/Types";
import i18n from "../../../../../i18n";

function getLabel(property: string, option: string) {
  return i18n.t(`common:${property}.options.${option}`);
}

const normalize = normalizeOptions(getLabel);

type AddressFormOptionsType = {
  salutation: OptionT[],
  salutationTitle: OptionT[],
};

export const AddressFormOptions: AddressFormOptionsType = normalize({
  salutation: ["Frau", "Herr"],
  salutationTitle: ["", "Doktor", "Professor"],
});

export default AddressFormOptions;
